module.exports = __webpack_public_path__ + "media/img/why/smartvenue-82a91b072feff1be07923af93a182108.png";